import React, { useEffect, useRef, useState } from 'react'
import $ from 'jquery'

import "./core-bar.css"

var stripesAnim: any;
var calcPercent: any;

const CoreBar = (props: CoreBarConfig) => {
	const root = useRef(null);

	useEffect(() => {
		const $progress = $('.core-bar-progress-bar');
		const $percent = $('.core-bar-percentage');
		const $stripes = $('.core-bar-progress-stripes');

		$progress.animate({
			width: (props.percentage * 100) + "%"
		}, 100);
		if(!calcPercent) {
			calcPercent = setInterval(() => {
				//loop through the items
				$percent.text(Math.floor(($progress.width() / $('.core-bar-loader').width()) * 100) + '%');
			});
	
		}
		
		/* STRIPES ANIMATION */
		const stripesAnimate = () => {
			if(!stripesAnim) {
				$stripes.text('////////////////////////');
				// let width = 100;
				animating();
				stripesAnim = setInterval(() => {
					// width += 100;
					animating()
				}, 2500);
			}
		}

		const animating = () => {
			if(!root.current) {
				clearInterval(stripesAnim);
				clearInterval(calcPercent);
				stripesAnim = null;
				calcPercent = null;
			}
			$stripes.animate({
				left: "-=30px"
			}, 2500, "linear");

			setTimeout(() => {
				$stripes.append('////////////////////////');
				// $stripes.css('width', width + '%')
			}, 2500);
		}

		const setSkin = (skin: string) => {
			$('.core-bar-loader').attr('class', 'core-bar-loader ' + skin);
			$('.core-bar span').hasClass('loaded') ? $('span').attr('class', 'loaded ' + skin) : $('.core-bar span').attr('class', skin);
		}
		setSkin(props.color);

		/* CHANGE LOADER SKIN */
		$('.core-bar-skin').click(function () {
			var whichColor = $(this).attr('id');
			setSkin(whichColor);
		});

		// Call function to animate stripes
		stripesAnimate();
	}, [props.percentage])
	return (
		<div ref={root} className="core-bar modal-disable-select"  style={{
			width: '100%',
    		height: '100%'
		}}>
			<div className="core-bar-loader">
				<div className="core-bar-progress-bar" style={{position: 'relative'}}>
					<div className="core-bar-progress-stripes" style={{position: 'absolute', 'left': '0px', width: 'auto'}}></div>
					<div className="core-bar-percentage">0%</div>
				</div>
			</div>
		</div>
	);

};

export interface CoreBarConfig {
	color: CoreBarColorType;
	percentage: number;

	/**Called internally to stop the animation */
	forceStopAnimation?: () => void;
}

export enum CoreBarColorType {
	red = 'core-bar-red',
	blue = 'core-bar-blue',
	green = 'core-bar-green',
	yellow = 'core-bar-yellow',
	purple = 'core-bar-purple',
	gray = 'core-bar-gray'
}

export default CoreBar;